import React from "react";
import "src/components/Asset2dImage/configureAsset.css";
import { getAssetImg } from "src/apis/ConfigureAsset3d";
import { useState, useEffect } from "react";
import { base64Suffix } from "src/util/utilFunctions";
import { useNavigate } from "react-router-dom";
/**
 * @param {assetId} id of the asset to load image of 
 * @param {SetDataForUpdate} callback function used to set the loaded image data in the parent such that its is visible to ther child components                         
 * @param {items} complete data of the sensors of the asset to allow complete visualization of the item state 
 * @param {updateSelf} boolean that monitors if an update of asset image has been done
 * @param {resetUpdateSelf} callback function to reset updateSelf boolean after it has been used to trigger the rerender
 */
function VisualizeAsset2d({ assetId, SetDataForUpdate, items,updateSelf,resetUpdateSelf }) {
  const [base64Image, setBase64Img] = useState(null);
  const [sensorData, setSensorData] = useState(null);

  const handleClick = (data) => {
    window.alert(data);
  };

  const navigate = useNavigate();

  const handleDivClick = () => {
    navigate("/dashboard/alerts-and-notifications"); 
  };
  const fetchData = async () => {
    try {
      await getAssetImg(assetId).then((res) => {
        SetDataForUpdate(res);
        console.log("apii response : ", res);
        const concatImg = base64Suffix.concat(res.image);
        setSensorData(res.coordinateDto);
        console.log("image concat successful :", concatImg);
        setBase64Img(concatImg);
      });
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
       fetchData();
  }, [assetId]); // make function fire on first render

  useEffect(() => {
    if(assetId && updateSelf){
    console.log("updating: ")
    fetchData();
    const closeForm=false; const  updateVisualizeAssetComp=false //declaration for code leggibility
    resetUpdateSelf(closeForm,updateVisualizeAssetComp);
   
  }
}, [assetId,updateSelf]); // make function if form has been updated

  return (
    <>
      {base64Image && (
        <div className="ImagePreviewWrapper">
          <div className="image-preview" style={{ position: "relative" }}>
            <img src={base64Image} style={{ width: "100%", height: "100%" }} />
            {sensorData &&
              sensorData.map((sensor) => (
                <div
                  key={sensor.itemId}
                  className={`dot ${
                    sensor.itemIsAlarm ? "blinkingalarm" : "normal"
                  }`}
                  style={{
                    position: "absolute",
                    left: sensor.xpoint + "%",
                    top: sensor.ypoint + "%",
                  }}
                  onClick={sensor.itemIsAlarm ? handleDivClick : null} // Add onClick event handler conditionally
                >
                  <div
                    className={`labels ${
                      sensor.itemIsAlarm ? "alarmLabel" : ""
                    }`}
                    style={{ pointerEvents: sensor.itemIsAlarm ? "none" : "auto" }}
                  >
                    <div>
                      <h3>
                        {items.find((item) => item.id === sensor.itemId)
                          ?.itemType.name}
                      </h3>
                    </div>
                    <div>
                      Value:{" "}
                      <b>
                        {items.find((item) => item.id === sensor.itemId)
                          ?.valueWithOutUnit}
                      </b>
                    </div>
                    <div>Serial Number:{sensor.itemSn}</div>
                    <div>
                      Threshold Medium:{" "}
                      {items.find((item) => item.id === sensor.itemId)
                        ?.thresholdMedium}
                    </div>
                    <div>
                      Threshold Critical:{" "}
                      {items.find((item) => item.id === sensor.itemId)
                        ?.thresholdCritical}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
}

export default VisualizeAsset2d;
